// ./router.js
import React, { useEffect } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";

import "./assets/style/style.scss";
import "../src/assets/style/color.scss";
import "../src/assets/style/custome.scss";
import "../src/assets/style/fonts.scss";
import "../src/assets/style/height.scss";
import "../src/assets/style/responsive.scss";
import "../src/assets/style/width.scss";
import Login from "./Screen/Auth/Login";
import Register from "./Screen/Auth/Register";
import Forgot from "./Screen/Auth/Forgot";
import CreatePassword from "./Screen/Auth/CreatePassword";
import BlockedClient from "./Screen/Profile/Clients/BlockedClient";
import Layout from "./Screen/Layout/Layout";
import Dashboard from "./Screen/Dashboard/Dashboard";
import Admin from "./Screen/Admin/Admin";
import AdminList from "./Screen/Admin/Admin";
import AdminAdd from "./Screen/Admin/AdminAdd";
import Role from "./Screen/Roles/Role";
import RoleUpdate from "./Screen/Roles/RoleUpdate";
import MobileNavbar from "./Component/MobileNavbar/MobileNavbar";
import DeleteData from "./Screen/Profile/Clients/DeleteData";
import ClientList from "./Screen/Client/ClientList";
import ClientReport from "./Screen/Client/ClientReport";
import ClientActivity from "./Screen/Profile/Clients/ClientActivity";
import TeamSize from "./Screen/TeamSize/TeamSize";
import WalletHistory from "./Screen/WalletHistory/WalletHistory";
import AdminRecharge from "./Screen/AdminRecharge/AdminRecharge";
import RechargeHistory from "./Screen/RechargeHistory/RechargeHistory";
import WithdrawHistory from "./Screen/WithdrawHistory/WithdrawHistory";
import AnnounceResult from "./Screen/AnnounceResult/AnnounceResult";
import OverallResult from "./Screen/OverallResult/OverallResult";
import Report from "./Screen/Report/Report";
import Commission from "./Screen/Commission/Commission";
import Announcement from "./Screen/Announcement/Announcement";
import HolidayUpdate from "./Screen/HolidayUpdate/HolidayUpdate";
import HelpSupport from "./Screen/Helpsupport/HelpSupport";
import HelpChat from "./Screen/Helpsupport/HelpChat";
import AppTime from "./Screen/AppTime/AppTime";
import WinningReport from "./Screen/WinningReport/WinningReport";
import Sales from "./Screen/Sales/Sales";
import Cost from "./Screen/Cost/Cost";
import AddLink from "./Screen/Add Links/AddLink";
import LotPrice from "./Screen/LotPrice/LotPrice";
import DrawReport from "./Screen/DrawReport/DrawReport";
import WinnerAgency from "./Screen/WinnerAgency/WinnerAgency";
import NumberWise from "./Screen/NumberWise/NumberWise";
import HttpClient from "./Services/HttpClient";
import useStore from "./Screen/redux/store/useStore";
import AnnounceResultEdit from "./Screen/AnnounceResult/AnnounceResultEdit";
import PurchaseReport from "./Screen/PurchaseReport/PurchaseReport";
import ProtectedRoute from "./routes/ProtectedRoute";

const AppRoutes = () => {

  // Restore token
  let tokenUser = localStorage.getItem("token");
  let persistToken = sessionStorage.getItem("token");
  let token = tokenUser || persistToken;

  // Auto Logout Check
  // useEffect(() => {
  //   const lastClosedTime = localStorage.getItem("lastClosedTime");

  //   if (lastClosedTime) {
  //     const lastTime = new Date(parseInt(lastClosedTime));
  //     const now = new Date();

  //     const minutesDifference = (now - lastTime) / (1000 * 60);

  //     if (minutesDifference > 10) {
  //       // More than 10 min → logout
  //       localStorage.removeItem("token");
  //       sessionStorage.removeItem("token");
  //       token = null;
  //     }
  //   }
  // }, []);

  // Save close time on browser close
  useEffect(() => {
    const handleTabClose = () => {
      localStorage.setItem("lastClosedTime", Date.now().toString());
    };

    window.addEventListener("beforeunload", handleTabClose);
    return () => window.removeEventListener("beforeunload", handleTabClose);
  }, []);

  // Apply token to Axios
  if (token) {
    HttpClient.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  }

  return (
    <Routes>
      <Route
        path="/"
        element={token ? <Navigate to="/mobile-navbar" /> : <Login />}
      />
      <Route path="/forgot" element={<Forgot />} />
      <Route path="/create-password" element={<CreatePassword />} />
      <Route element={<Layout />}>
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute moduleCode="dashboard">
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/blocked-client"
          element={
            <ProtectedRoute moduleCode="blocked_client_list">
              <BlockedClient />
            </ProtectedRoute>
          }
        />
        <Route
          path="/delete-data"
          element={
            <ProtectedRoute moduleCode="delete_data">
              <DeleteData />
            </ProtectedRoute>
          }
        />
        <Route
          path="/client-activity"
          element={
            <ProtectedRoute moduleCode="client_activity">
              <ClientActivity />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin"
          element={
            <ProtectedRoute moduleCode="admins">
              <AdminList />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin"
          element={
            <ProtectedRoute moduleCode="admins">
              <AdminList />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin-add"
          element={
            <ProtectedRoute moduleCode="admins">
              <AdminAdd />
            </ProtectedRoute>
          }
        />
        <Route
          path="/role"
          element={
            <ProtectedRoute moduleCode="role_maping">
              <Role />
            </ProtectedRoute>
          }
        />
        <Route
          path="/role-update"
          element={
            <ProtectedRoute moduleCode="role_maping">
              <RoleUpdate />
            </ProtectedRoute>
          }
        />
        <Route path="/mobile-navbar" element={<MobileNavbar />} />
        <Route
          path="/client-list"
          element={
            <ProtectedRoute moduleCode="client">
              <ClientList />
            </ProtectedRoute>
          }
        />
        <Route
          path="/client-report"
          element={
            <ProtectedRoute moduleCode="client">
              <ClientReport />
            </ProtectedRoute>
          }
        />
        <Route
          path="/team-size"
          element={
            <ProtectedRoute moduleCode="client">
              <TeamSize />
            </ProtectedRoute>
          }
        />
        <Route
          path="/wallet-history"
          element={
            <ProtectedRoute moduleCode="client">
              <WalletHistory />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin-recharge"
          element={
            <ProtectedRoute moduleCode="admin_recharge">
              <AdminRecharge />
            </ProtectedRoute>
          }
        />
        <Route
          path="/recharge-history"
          element={
            <ProtectedRoute moduleCode="recharge_history">
              <RechargeHistory />
            </ProtectedRoute>
          }
        />
        <Route
          path="/withdraw-history"
          element={
            <ProtectedRoute moduleCode="widraw_history">
              <WithdrawHistory />
            </ProtectedRoute>
          }
        />

        <Route
          path="/announce-result"
          element={
            <ProtectedRoute moduleCode="announce_result">
              <AnnounceResult />
            </ProtectedRoute>
          }
        />
        <Route
          path="/announce-result-edit"
          element={
            <ProtectedRoute moduleCode="announce_result">
              <AnnounceResultEdit />
            </ProtectedRoute>
          }
        />
        <Route
          path="/overall-result"
          element={
            <ProtectedRoute moduleCode="overall_result">
              <OverallResult />
            </ProtectedRoute>
          }
        />
        <Route
          path="/report"
          element={
            <ProtectedRoute moduleCode="reports">
              <Report />
            </ProtectedRoute>
          }
        />
        <Route
          path="/commission"
          element={
            <ProtectedRoute moduleCode="commission_history">
              <Commission />
            </ProtectedRoute>
          }
        />
        <Route
          path="/announcement"
          element={
            <ProtectedRoute moduleCode="announcements">
              <Announcement />
            </ProtectedRoute>
          }
        />
        <Route
          path="/holiday-update"
          element={
            <ProtectedRoute moduleCode="holiday_update">
              <HolidayUpdate />
            </ProtectedRoute>
          }
        />
        <Route
          path="/help-support"
          element={
            <ProtectedRoute moduleCode="help_and_support">
              <HelpSupport />
            </ProtectedRoute>
          }
        />
        <Route
          path="/help-chat"
          element={
            <ProtectedRoute moduleCode="help_and_support">
              <HelpChat />
            </ProtectedRoute>
          }
        />
        <Route
          path="/app-time"
          element={
            <ProtectedRoute moduleCode="app_time_setting">
              <AppTime />
            </ProtectedRoute>
          }
        />
        <Route
          path="/winning-report"
          element={
            <ProtectedRoute moduleCode="reports">
              <WinningReport />
            </ProtectedRoute>
          }
        />
        <Route
          path="/purchase-report"
          element={
            <ProtectedRoute moduleCode="reports">
              <PurchaseReport />
            </ProtectedRoute>
          }
        />
        <Route
          path="/sales"
          element={
            <ProtectedRoute moduleCode="reports">
              <Sales />
            </ProtectedRoute>
          }
        />
        <Route
          path="/cost-report"
          element={
            <ProtectedRoute moduleCode="reports">
              <Cost />
            </ProtectedRoute>
          }
        />
        <Route
          path="/add-link"
          element={
            <ProtectedRoute moduleCode="links">
              <AddLink />
            </ProtectedRoute>
          }
        />
        <Route
          path="/lot-price"
          element={
            <ProtectedRoute moduleCode="lot_price_details">
              <LotPrice />
            </ProtectedRoute>
          }
        />
        <Route
          path="/draw-report"
          element={
            <ProtectedRoute moduleCode="reports">
              <DrawReport />
            </ProtectedRoute>
          }
        />
        <Route
          path="/cash-agency"
          element={
            <ProtectedRoute moduleCode="price_details">
              <WinnerAgency />
            </ProtectedRoute>
          }
        />
        <Route
          path="/number-wise"
          element={
            <ProtectedRoute moduleCode="reports">
              <NumberWise />
            </ProtectedRoute>
          }
        />
      </Route>
    </Routes>
  );
};

export default AppRoutes;
